import { render } from "./Import_Tenants.vue?vue&type=template&id=71f33caa"
import script from "./Import_Tenants.vue?vue&type=script&lang=js"
export * from "./Import_Tenants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__